export const CONSTANTS = {
	/** Nucaptcha */
	DEFAULT_REPORT_SEGMENT: 'Campaign',
	ACTION_SCORE_KEY: 'SCORE',
	ACTION_VALIDATE_KEY: 'VALIDATE',
	CAPTCHA_REQUIRED: 'Captcha required',
	INVALID_CAPTCHA: 'Invalid captcha',
	BLANK_CATPCHA: 'invalid data: captchValidate.nuCaptchaAnswer',
	CAPTCHA_PLACEMENT: 'FormSubmission',
	CAPTCHA_BASE_URL: 'https://api-mastercard-dxp.nd.nudatasecurity.com/2.2/w/',
	NUCAPTCHA_CLIENT_ID: 'w-171830',

	/** Pardot */
	PARDOT_KEY: 'PARDOT',
};
